import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasEmpleadoprestamosListaComponent () {
  var $ctrl = this
  $ctrl.seleccionar = seleccionar

  function seleccionar (data) {
    $ctrl.seleccionarEmpleado({$event: {data: data}})
  }
}

module.component('finanzasEmpleadoprestamosLista', {
  controller: FinanzasEmpleadoprestamosListaComponent,
  template,
  bindings: {
    data: '<',
    seleccionarEmpleado: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/empleadoprestamos/components/lista/component.js